type PushMessage = { id: string; employeeId: string; type: string };

/**
 * Create a new broadcast channel if the browser supports it.
 */
function createChannel() {
  try {
    if (typeof BroadcastChannel === "undefined") {
      return null;
    }

    return new BroadcastChannel("push");
  } catch (_error) {
    return null;
  }
}

/**
 * Channel for communicating query changes between service worker and the main thread.
 */
export class PushBroadCastChannel {
  private static readonly channel = createChannel();

  static broadcast(message: PushMessage) {
    PushBroadCastChannel.channel?.postMessage(message);
  }

  static listen(callback: (message: PushMessage) => void) {
    const listener = (event: MessageEvent) => {
      callback(event.data);
    };

    PushBroadCastChannel.channel?.addEventListener("message", listener);
    return () => {
      PushBroadCastChannel.channel?.removeEventListener("message", listener);
    };
  }
}
